<div class="cl-login-shell">
  <div class="cl-login-card">
    <div class="cl-login-brand">OLS Change Logs</div>
    <p class="cl-login-tag">Internal Engineering Access</p>

    <div class="cl-login-divider"></div>

    <div class="cl-google-btn-wrap">
      <div #googleBtn></div>
    </div>

    <p class="cl-loading" *ngIf="loading">Signing in&hellip;</p>
    <p class="cl-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <p class="cl-login-footnote">Authorized team members only.</p>
  </div>
</div>
